module.exports = __webpack_public_path__ + "42628964d356a4ae5daa46702d001b5c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Camp/leto-23.jpg
// module id = 1164
// module chunks = 0